module.exports = __webpack_public_path__ + "media/icon_transaction/frog_1-4c4a9c89.png";